import Button from '@components/atoms/button';
import FFHModal from '@components/modal';
import {
  BodyRegular,
  BodySmallRegular,
  H2
} from '@components/atoms/typography';

type TransferErrorModalProps = {
  isOpen: boolean;
  title: string;
  messages: string[];
  onDismiss: () => void;
};

export const TransferErrorModal = ({
  isOpen,
  title,
  messages,
  onDismiss
}: TransferErrorModalProps) => (
  <FFHModal open={isOpen} handleClose={onDismiss} title={title}>
    <div
      className="flex flex-col gap-4 p-6 max-w-[460px]"
      data-cy="transfer-error-modal"
    >
      <H2>{title}</H2>
      {messages.length === 1 ? (
        <BodyRegular textColor="text-neutral-700">{messages[0]}</BodyRegular>
      ) : (
        <ul className="list-disc list-inside flex flex-col gap-1">
          {messages.map((message, index) => (
            <li key={`error-${index}`}>
              <BodySmallRegular textColor="text-neutral-700">
                {message}
              </BodySmallRegular>
            </li>
          ))}
        </ul>
      )}
      <div className="flex justify-end">
        <Button
          variant="primary"
          onClick={onDismiss}
          data-cy="transfer-error-dismiss"
        >
          Got it
        </Button>
      </div>
    </div>
  </FFHModal>
);
